<template>
  <button v-if="showCopyButton" @click="copyKey(item.code)" class="btn btn-outline-secondary btn-sm d-none d-xl-inline me-1"><font-awesome-icon :icon="['fas', 'copy']" /></button>
  <span class="text-primary fw-bold">{{ item.name }}&#8203;</span>
  <span v-if="!!substituteItemCode"><sup class="text-secondary ms-1">{{ substituteItemCode }}</sup><sup v-if="userSettingsStore.data.developerMode && substituteItemCode !== item.code" class="text-secondary ms-1 text-decoration-line-through">{{ item.code }}</sup></span>
  <span v-else><sup class="text-secondary ms-1">{{ item.code }}</sup></span><br>
  <span v-if="item.name.localeCompare(item.description) != 0" class="fs-6 text-melodi ms-1">{{ item.description }}</span>
</template>

<script setup lang="ts">
import { toast } from 'vue3-toastify';
import { useI18n } from 'vue-i18n';
import { useUserSettingsStore } from '@/stores';
import Item from '@/models/frontend/Item';

const userSettingsStore = useUserSettingsStore();
const i18n = useI18n();

defineProps({
  item: { type: Object as () => Item, required: true },
  showCopyButton: { type: Boolean, default: false },
  substituteItemCode: { type: String },
});

const copyKey = (itemCode: string) => {
  copyToClipboardWithMessage(itemCode, i18n.t('statement.itemCopied', { item: itemCode }));
}

function copyToClipboardWithMessage(clipboardContent: string, message: string) {
  navigator.clipboard.writeText(clipboardContent).then(
    () => toast.success(message, { autoClose: 1000 }),
    () => toast.error(i18n.t('error.copiedError'), { autoClose: 1000 })
  );
}
</script>
